import jakartaLogo from '../assets/JakartaLogo.svg';
import baliLogo from '../assets/BaliLogo.svg';
import semarangLogo from '../assets/SemarangLogo.svg';

import bannerGmis from '../assets/Banner-GMIS Students.png';
import preschool from '../assets/PRESCHOOL.png';
import primarySchool from '../assets/PRIMARY SCHOOL.png';
import juniorSchool from '../assets/JUNIOR SCHOOL.png';
import seniorSchool from '../assets/SENIOR SCHOOL.png';
import whyIbCambridge from '../assets/WHY GMIS-IB,Cambridge.JPG';
import whyHolistic from '../assets/WHY GMIS - HOLISTIC.png';
import whyAcademic from '../assets/WHY GMIS-Academic Excellence.jpeg';

import bseisiLogo from '../assets/BSEISI.png';
import cambridgeLogo from '../assets/CAMBRIDGE.png';
import ibLogo from '../assets/IB CONTINUUM.png';
import tutlogo from '../assets/TUT WURI HANDAYANI.png';

import locJakarta from '../assets/GMIS JAKARTA.png';
import locBali from '../assets/GMIS BALI.png';
import locSemarang from '../assets/GMIS SEMARANG.png';


const u = (id, w) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const STAT_NUMS = ['1,000+', '25+', '100%', '30+', '75+'];

export const LOCS = [
  { name: 'GMIS Jakarta', region: 'Jakarta', domain: 'gmis.sch.id', url: 'https://gmis.sch.id', logo: jakartaLogo },
  { name: 'GMIS Bali', region: 'Bali', domain: 'gmisbali.sch.id', url: 'https://gmisbali.sch.id', logo: baliLogo },
  { name: 'GMIS Semarang', region: 'Semarang', domain: 'gmissemarang.sch.id', url: 'https://gmissemarang.sch.id', logo: semarangLogo },
];

export const IMG = {
  hero: [
    bannerGmis,
    u('1759143101324-d375443f1955', 1800),
    u('1577896851231-70ef18881754', 1800),
  ],
  about: locJakarta,
  why: [
    whyIbCambridge,
    whyHolistic,
    whyAcademic,
  ],
  level: [
    preschool,
    primarySchool,
    juniorSchool,
    seniorSchool,
  ],
  loc: [
    locJakarta,
    locBali,
    locSemarang,
  ],
  accred: [
    ibLogo,
    cambridgeLogo,
    bseisiLogo,
    tutlogo,
  ],
};
